<template>
  <v-container xv-if='LOGGED_IN && false' id="page">

    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"/>
    </v-overlay>

    <v-row>
      <v-col>
        <span class="text-subtitle-2 secondary--text">Locations</span>
      </v-col>
    </v-row>


    <v-row>
      <v-col class="col-12 col-sm-6 col-lg-4 col-xl-3" v-for="l in locations" :key="l.xid">
        <Transition name="v-scale-transition">
          <Location v-if="!loading" :location="l" class="mx-auto fill-height d-flex flex-column" />
        </Transition>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <span class="text-subtitle-2 secondary--text">Staff</span>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="col-12 col-sm-6 col-lg-4 col-xl-3" v-for="s in staff" :key="s.xid">
          <Staff :staff="s" />
      </v-col>
    </v-row>



  </v-container>
</template>

<style lang="scss">
#page{
  .v-skeleton-loader__image{ height: 200px; }
}

</style>

<script>
import { mapActions, mapGetters } from 'vuex'
import Location from './components/Location'
import Staff from './components/Staff'

export default {
  name: 'customer-contacts',

  components: {
    Location, Staff
  },

  data: () => ({
    loading: false,
    locations: [],
    staff: [],
  }),

  computed: {
    ...mapGetters('Auth', ['LOGGED_IN']),
  },

  watch:{
  },

  methods: {
    ...mapActions('Auth', ['REQUIRE_LOGIN']),
    ...mapActions('UI', ['SET_PAGE_TITLE', 'SHOW_NAVBARS']),
    ...mapActions('API', ['API']),

    refresh(){
      this.loading = true;
      this.loadLocations()
      .then(this.loadStaff)
      .finally(() => {
        setTimeout(() => { this.loading = false }, 1);
      });
    },

    loadLocations(){
      this.locations = [];
      return this.API({ method: 'GET', endpoint: `customer_portal/locations` })
      .then(locations => {
        this.locations = locations;
      })
    },

    loadStaff(){
      this.staff = [];
      return this.API({ method: 'GET', endpoint: `customer_portal/staff` })
      .then(staff => {
        this.staff = staff;
      })
    },



  },
  mounted() {
    this.REQUIRE_LOGIN(()=>{
      this.SHOW_NAVBARS();
      this.SET_PAGE_TITLE('Contacts');
      this.refresh()
    });
  }
};
</script>
7